export default __webpack_public_path__ + "static/media/h2.6996900a.jpg";